'use client'

import { createContext } from 'react'

import { AuthorizationState } from './authorization.model'

export const AuthorizationContext = createContext<AuthorizationState | null>(null)
